module.exports = __webpack_public_path__ + "img/2022_10_dandelion_nijojo_fin_web.9d93e57d.jpg";